import React, { Suspense } from 'react'

import { useStoreState } from 'store'
import { retry } from '../../utils/retry'

const MobileFilters = React.lazy(() => retry(() => import(/* webpackChunkName: "MobileFilters" */ './MobileFilters')))

export default function Filters() {
  const isDesktop = useStoreState(state => state.dimensions.isDesktop)
  const hasInitialized = useStoreState(state => state.initialization.hasInitialized)
  const flags = useStoreState(state => state.featureFlags.flags)
  const tableTopPastViewport = useStoreState(state => state.ui?.tableTopPastViewport)

  return (
    <>
      <div
        className={`bg-gray-light pb-4 w-full z-layer-three${
          flags.showLeftRailFilters ? '' : ` pos-sticky${tableTopPastViewport ? ' filter__shadow' : ''}`
        }`}
        data-testid="table-filters"
        style={{
          top: 0,
        }}
      >
        <div
          className={`gutter wrapper mb-0 bg-white md:pb-4 z-layer-three pt-2 mobile-filters__wrapper
                        ${
                          flags.advertiserDisclosureText ? `preamp-mobile-filters__wrapper` : `mobile-filters__wrapper`
                        }`}
        >
          {!isDesktop && (
            <Suspense fallback={<div />}>
              <div className="display-flex flex-wrap" data-testid="MobileFilters">
                {hasInitialized ? <MobileFilters /> : <div />}
              </div>
            </Suspense>
          )}
        </div>
      </div>
    </>
  )
}
